import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';

import PushNotificationDetails from './PushNotificationDetails/PushNotificationDetails';
import { HealtheraButton } from '../../../../healtheraComponents';
import { ROUTES } from '../../../Routes/constants';

import { Box } from 'reflexbox';
import { LinearProgress } from '@material-ui/core';

const validationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  body: Yup.string().required('Body is required'),
  app_deep_link: Yup.string().required('Deep Link is required'),
  note: Yup.string().optional(),
  file: Yup
    .mixed()
    .required('Please upload a CSV file')
    .test(
      'fileType',
      'File must be in CSV format.',
      (value) => value && value.type === 'text/csv',
    )
    .test(
      'fileSize',
      'File size must not exceed 18MB',
      (value) => value && value.size <= 18 * 1024 * 1024,
    ),
});

const CreatePushNotification = ({ onSubmit, error, isCreating, appDeepLinks }) => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [isLocallyCreating, setIsLocallyCreating] = useState(false);

  const initialValues = {
    title: '',
    body: '',
    note: '',
    app_deep_link: '',
    file: null,
  };

  const { setValues, values, errors: validationErrors, validateForm } = useFormik({
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    validateForm();
  }, [validateForm]);

  useEffect(() => {
    if (isLocallyCreating && !isCreating && !error) {
      setIsLocallyCreating(false);
      history.push(ROUTES.CAMPAIGNS);
    } else if (isLocallyCreating && !isCreating && error) {
      setIsLocallyCreating(false);
    }
  }, [history, error, isLocallyCreating, isCreating]);

  const changeHandler = (updatedCampaign) => {
    const { ...updatedFields } = updatedCampaign;
    setValues(currentValues => ({ ...currentValues, ...updatedFields }));
  };

  const handleSubmit = () => {
    const [error] = Object.values(validationErrors);
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    } else {
      setIsLocallyCreating(true);
      const { ...newCampaign } = values;
      onSubmit(newCampaign);
    }
  };

  return (
    <>
      {isLocallyCreating && (<Box sx={{ width: '50%' }}>
          <LinearProgress color='secondary' />
        </Box>
      )}
      <PushNotificationDetails
        campaign={values}
        appDeepLinks={appDeepLinks}
        onUpdate={changeHandler}
        disabled={isCreating}
        persist
      />
      <ButtonContainer>
        <HealtheraButton
          disabled={!!isLocallyCreating}
          onClick={handleSubmit}>
          Save Draft
        </HealtheraButton>
      </ButtonContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  border-radius: 15px;
  margin-top: 20px;
  padding: 20px;
  width: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 20px;
`;

export default CreatePushNotification;
